const units = {
  IMPERIAL: {
    length: "inch",
    area: {
      units: "ha",
      convert(size) {
        return Number((size / 2.47105).toFixed(2));
      },
    },
    volume: "ounce",
    weight: {
      units: "lbs",
      convert(weight) {
        return Number((weight * 2.20462).toFixed(2));
      },
    },
    temperature: {
      units: "F",
      convert(celsius) {
        return (celsius * 9) / 5 + 32;
      },
    },
  },
  METRIC: {
    length: "mt",
    area: {
      units: "ac",
      convert(size) {
        return Number((size * 2.47105).toFixed(2));
      },
    },
    volume: "lt",
    weight: {
      units: "kgs",
      convert(weight) {
        return Number((weight / 2.20462).toFixed(2));
      },
    },
    temperature: {
      units: "C",
      convert(fern) {
        return ((fern - 32) * 5) / 9;
      },
    },
  },
};

export default units;
